export const projectsData = [


	{
		projectName: "VEHICLE_SELLING",
		projectDescription:
			"I have developed a project that includes role-based authentication, allowing users to access vehicle details. After selecting a vehicle, users can add it to their cart and proceed to purchase it. The project also includes a payment gateway for secure transactions. Additionally, once the product is delivered, the system will display a notification indicating successful delivery.",
		imageUrl:
			"https://d1csarkz8obe9u.cloudfront.net/posterpreviews/car-sale-poster-design-template-3e0a62f11df4b64e6c47e66ac0c5eaad_screen.jpg?ts=1661225248",
		projectUrl: "https://vechicle-selling-application.onrender.com/",
		codeUrl: "https://github.com/Sandeep-Raj-CSE/Vehicle_Selling",
	},

	
	{
		projectName: "Blog Application!",
		projectDescription:
			"In the Blog Application project, the first step is to authenticate the application itself. Once authenticated, users can read existing blogs and create their own blogs. Users also have the ability to update their blogs..",
		imageUrl:
			"https://cdn.pixabay.com/photo/2012/05/07/18/57/blog-49006_1280.png",
		projectUrl: "https://sandy-7970-blog.onrender.com/",
		codeUrl: "https://github.com/Sandeep-Raj-CSE/Blog_Application",
	},
	{
		projectName: "Pharmacy_Management!",
		projectDescription:
			"In this project, we have implemented various essential functions that are typically found in a pharmacy website. These functionalities include login authentication, role-based access control, comprehensive medicine details management, efficient billing system for a specific user, and doctor-patient appointment scheduling.",
		imageUrl:
			"https://st4.depositphotos.com/1001599/25156/v/600/depositphotos_251567618-stock-illustration-online-prescription-system-concept-vector.jpg",
		// projectUrl: "#",
		codeUrl: "https://github.com/Sandeep-Raj-CSE/Pharmacy_Management_System",
	},
	{
		projectName: "TutoFy (E-Learning) !",
		projectDescription:
			"Students can easily search for courses based on teacher name, subject name, teacher rating, and apply filters based on course and teacher ratings. The platform also includes a progress monitoring feature to track individual progress. Additionally, the website ensures a secure authentication process for users.",
		imageUrl:
			"https://cdn.pixabay.com/photo/2020/03/09/13/23/e-learning-4915655_1280.png",
		// projectUrl: "#",
		codeUrl: "https://github.com/Sandeep-Raj-CSE/Pharmacy_Management_System",
	},
	{
		projectName: "Calculator!",
		projectDescription:
			"One of the most powerful tools in the world is a simple calculator - it holds the power of countless complex calculations at your fingertips.!",
		imageUrl:
			"https://images.freeimages.com/images/large-previews/96d/one-two-three-keys-from-calculator-1242298.jpg",
		projectUrl: "https://sandeep-raj-cse.github.io/calculator-react/",
		codeUrl: "https://github.com/Sandeep-Raj-CSE/calculator-react",
	},
	
];
